export default [
  {
    key: "increasement",
    sortable: false,
    sortField: "createdAt",
    label: "label.no",
  },
  {
    key: "text",
    sortable: false,
    label: "field.messages",
    class: "w-half break-spaces",
  },
  {
    key: "isTrain",
    sortable: false,
    label: "field.training",
  },
  {
    key: "createdAt",
    sortable: false,
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
